import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../../app/store";
import { anomalieFilter } from "./anomalieTypes";

const initialState: anomalieFilter
    = {

    groesserKleinerListe: ["Größer (>)", "Kleiner (<)"],

    anteilTage: "Größer (>)",
    anteilTageTemp: "Größer (>)",
    anteilTageVorher: "Größer (>)",
    anteilTageWert: 0,
    anteilTageWertTemp: 0,
    anteilTageWertVorher: 0,

    anomalie: "Größer (>)",
    anomalieTemp: "Größer (>)",
    anomalieVorher: "Größer (>)",
    anomalieWert: 0,
    anomalieWertTemp: 0,
    anomalieWertVorher: 0,

    signifikanz: ["niedrig", "mittel", "hoch"],
    signifikanzTemp: ["niedrig", "mittel", "hoch"],
    signifikanzVorher: ["niedrig", "mittel", "hoch"],

    anomalietyp: ["c", "d", "e", "v"],
    anomalietypTemp: ["c", "d", "e", "v"],
    anomalietypVorher: ["c", "d", "e", "v"],

    isChangedAnomalie: false,
    isFirstInitLoad: true,
    isAnomaliewertAktiv: false,
}

const anomalieFilterSlice = createSlice({
    name: "anomalieFilter",
    initialState,
    reducers: {

        setAnteilTageTemp: (state, action: PayloadAction<string>) => {
            state.anteilTageTemp = action.payload;
        },
        setAnteilTage: (state) => {
            state.anteilTage = state.anteilTageTemp;
            state.anteilTageVorher = state.anteilTageTemp;
        },
        resetAnteilTage: (state) => {
            state.anteilTage = state.anteilTageVorher;
            state.anteilTageTemp = state.anteilTageVorher;
        },
        setAnteilTageWertTemp: (state, action: PayloadAction<number>) => {
            state.anteilTageWertTemp = action.payload;
        },
        setAnteilTageWert: (state) => {
            state.anteilTageWert = state.anteilTageWertTemp;
            state.anteilTageWertVorher = state.anteilTageWertTemp;
        },
        resetAnteilTageWert: (state) => {
            state.anteilTageWert = state.anteilTageWertVorher;
            state.anteilTageWertTemp = state.anteilTageWertVorher;
        },
        setAnomalieTemp: (state, action: PayloadAction<string>) => {
            state.anomalieTemp = action.payload;
        },
        setAnomalie: (state) => {
            state.anomalie = state.anomalieTemp;
            state.anomalieVorher = state.anomalieTemp;
        },
        resetAnomalie: (state) => {
            state.anomalie = state.anomalieVorher;
            state.anomalieTemp = state.anomalieVorher;
        },
        setAnomalieWertTemp: (state, action: PayloadAction<number>) => {
            state.anomalieWertTemp = action.payload;
        },
        setAnomalieWert: (state) => {
            state.anomalieWert = state.anomalieWertTemp;
            state.anomalieWertVorher = state.anomalieWertTemp;
        },
        resetAnomalieWert: (state) => {
            state.anomalieWert = state.anomalieWertVorher;
            state.anomalieWertTemp = state.anomalieWertVorher;
        },
        addSignifikanzTemp: (state, action: PayloadAction<string>) => {
            state.signifikanzTemp.push(action.payload);
        },
        removeSignifikanzTemp: (state, action: PayloadAction<string>) => {
            const index = state.signifikanzTemp.indexOf(action.payload);
            if (index > -1) {
                state.signifikanzTemp.splice(index, 1);
            }
        },
        setSignifikanz: (state) => {
            state.signifikanz = state.signifikanzTemp;
            state.signifikanzVorher = state.signifikanzTemp;
        },
        resetSignifikanz: (state) => {
            state.signifikanz = state.signifikanzVorher;
            state.signifikanzTemp = state.signifikanzVorher;
        },
        addAnomalietypTemp: (state, action: PayloadAction<string>) => {
            state.anomalietypTemp.push(action.payload);
        },
        removeAnomalietypTemp: (state, action: PayloadAction<string>) => {
            const index = state.anomalietypTemp.indexOf(action.payload);
            if (index > -1) {
                state.anomalietypTemp.splice(index, 1);
            }
        },
        setAnomalietyp: (state) => {
            state.anomalietyp = state.anomalietypTemp;
            state.anomalietypVorher = state.anomalietypTemp;
        },
        resetAnomalietyp: (state) => {
            state.anomalietyp = state.anomalietypVorher;
            state.anomalietypTemp = state.anomalietypVorher;
        },
        setIsChangedAnomalie: (state, action: PayloadAction<boolean>) => {
            state.isChangedAnomalie = action.payload;
        },
        setIsFirstInitLoad: (state, action: PayloadAction<boolean>) => {
            state.isFirstInitLoad = action.payload;
        },
        setIsAnomaliewertAktiv: (state, action: PayloadAction<boolean>) => {
            state.isAnomaliewertAktiv = action.payload;
        }
    }
});



// Selectors

export const selectGroesserKleinerListe = (state: RootState): string[] => state.anomalieFilter.groesserKleinerListe;
export const selectAnteilTageTemp = (state: RootState): string => state.anomalieFilter.anteilTageTemp;
export const selectAnteilTage = (state: RootState): string => state.anomalieFilter.anteilTage;
export const selectAnteilTageWert = (state: RootState): number => state.anomalieFilter.anteilTageWert;
export const selectAnteilTageWertTemp = (state: RootState): number => state.anomalieFilter.anteilTageWertTemp;
export const selectAnomalieTemp = (state: RootState): string => state.anomalieFilter.anomalieTemp;
export const selectAnomalie = (state: RootState): string => state.anomalieFilter.anomalie;
export const selectAnomalieWertTemp = (state: RootState): number => state.anomalieFilter.anomalieWertTemp;
export const selectAnomalieWert = (state: RootState): number => state.anomalieFilter.anomalieWert;
export const selectSignifikanzTemp = (state: RootState): string[] => state.anomalieFilter.signifikanzTemp;
export const selectIsFirstInitLoad = (state: RootState): boolean => state.anomalieFilter.isFirstInitLoad
export const selectSignifikanz = (state: RootState): string[] => state.anomalieFilter.signifikanz;
export const selectAnomalietypTemp = (state: RootState): string[] => state.anomalieFilter.anomalietypTemp;
export const selectAnomalietyp = (state: RootState): string[] => state.anomalieFilter.anomalietyp;
export const selectIsChangedAnomalie = (state: RootState): boolean => state.anomalieFilter.isChangedAnomalie;
export const selectIsAnomaliewertAktiv = (state: RootState): boolean => state.anomalieFilter.isAnomaliewertAktiv;

// Actions
export const {
    setAnteilTageTemp,
    setAnteilTage,
    resetAnteilTage,
    setAnteilTageWertTemp,
    setAnteilTageWert,
    resetAnteilTageWert,
    setAnomalieTemp,
    setAnomalie,
    resetAnomalie,
    setAnomalieWertTemp,
    setAnomalieWert,
    resetAnomalieWert,
    addSignifikanzTemp,
    removeSignifikanzTemp,
    setSignifikanz,
    resetSignifikanz,
    addAnomalietypTemp,
    removeAnomalietypTemp,
    setAnomalietyp,
    resetAnomalietyp,
    setIsChangedAnomalie,
    setIsFirstInitLoad,
    setIsAnomaliewertAktiv
}
    = anomalieFilterSlice.actions;

export default anomalieFilterSlice.reducer;




